// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"326":"08bb8b49","670":"ddca58b5"}[chunkId] + ".chunk.js";
};